import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

// Field lengths are predetermined by https://atlassian.design/patterns/forms/
type FieldWidth = '75px' | '150px' | '250px' | '350px' | '500px';

const getFieldContainerStyles = (width: FieldWidth) =>
	xcss({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		width,
	});

export const FieldContainer = ({
	width,
	children,
}: React.PropsWithChildren<{ width: FieldWidth }>) => {
	// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
	return <Box xcss={getFieldContainerStyles(width)}>{children}</Box>;
};
